import Image from '@/app/components/Image';

export const FeatureCardsAppUI = () => {
  return (
    <div className="relative pb-0 md:pb-20" data-cy="feature-cards-wrapper">
      <div
        className="overflow-x-hidden py-4.5 lg:py-10"
        data-cy="feature-cards-container"
      >
        <div className="relative right-[35%] aspect-180/59 w-[170%] py-4.5 md:right-[0%] md:w-full">
          <Image
            fill
            format="png"
            sizes="100vw"
            className="object-contain"
            data-cy="feature-cards-image"
            localizedAlt="membership_feature_card_alt_text"
            localizedSrc="membership_redesign_feature_cards_app_ui"
          />
        </div>
      </div>
    </div>
  );
};
